import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React, { FC, useMemo, useState } from 'react';
import { department } from '../types';
import { Image } from '../../../components/Image';
import { STYLE_VARS } from '../../../constants/style-vars';
import { ViewProps } from 'react-native';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { FONTS } from '../../../constants';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import {
  club_facility,
  club_management,
  food_beverages_event,
  other_icon,
} from '../../../assets/base64';
import { TextInput } from '../../../components/TextInput/TextInput';

interface DepartmentSelectProps extends ViewProps {
  selectItem?: department;
  onSelect?: (department: department) => void;
  otherText?: string;
  onChangeOtherText?: (text: string) => void;
}

const DepartmentSelect: FC<DepartmentSelectProps> = ({
  selectItem,
  onSelect,
  otherText,
  onChangeOtherText,
  ...props
}) => {
  const isDesktop = useIsDesktop();
  const [departmentText, setDepartmentText] = useState<string>('');
  const listDepartment = useMemo(() => {
    const arr: {
      name: department;
      icon: any;
      title: string;
    }[] = [
      {
        name: 'foodBeverage',
        title: 'Food and Beverage Events',
        icon: IS_WEB
          ? addBase64Prefix(food_beverages_event)
          : require('../../../assets/food-beverage-event.png'),
      },
      {
        name: 'clubFacilities',
        title: 'Club Facilities',
        icon: IS_WEB
          ? addBase64Prefix(club_facility)
          : require('../../../assets/club-facility.png'),
      },
      {
        name: 'clubManagement',
        title: 'Club Management',
        icon: IS_WEB
          ? addBase64Prefix(club_management)
          : require('../../../assets/club-management.png'),
      },
      {
        name: 'other',
        title: 'Other',
        icon: IS_WEB
          ? addBase64Prefix(other_icon)
          : require('../../../assets/other-icon.png'),
      },
    ];
    return arr;
  }, []);

  return (
    <View {...props}>
      <View
        style={{
          marginBottom: 20,
          paddingRight: 10,
          width: isDesktop() ? '25%' : undefined,
          marginTop: 5,
        }}
      >
        <Text
          style={{
            color: STYLE_VARS.textColor,
            textTransform: 'uppercase',
            fontFamily: FONTS.IowanOldStyleBTRoman,
            fontSize: 13,
            fontWeight: '500',
          }}
        >
          Select Department
        </Text>
      </View>
      <View
        style={{
          flexDirection: isDesktop() ? 'row' : undefined,
          justifyContent: isDesktop() ? 'space-between' : undefined,
          flexWrap: isDesktop() ? 'wrap' : undefined,
          width: isDesktop() ? '75%' : undefined,
        }}
      >
        {listDepartment.map((department) => (
          <View
            style={{
              width: isDesktop() ? '45%' : undefined,
            }}
            key={department.name}
          >
            <TouchableOpacity
              key={department.name}
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                alignSelf: 'flex-start',
                marginBottom: 20,
              }}
              onPress={() => {
                if (onSelect) onSelect(department.name);
              }}
            >
              <View
                style={{
                  width: 26,
                  height: 26,
                  borderRadius: 24,
                  borderWidth: 1,
                  borderColor: STYLE_VARS.primaryColor,
                  backgroundColor:
                    department.name === selectItem
                      ? STYLE_VARS.primaryColor
                      : 'white',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 10,
                }}
              >
                <Image
                  source={department.icon}
                  style={{
                    width: 16,
                    height: 16,
                    resizeMode: 'contain',
                    tintColor:
                      department.name === selectItem
                        ? 'white'
                        : STYLE_VARS.primaryColor,
                  }}
                />
              </View>
              <Text
                style={{
                  fontFamily: FONTS.AvenirMedium,
                  fontSize: 13,
                  textTransform: 'uppercase',
                  color:
                    department.name === selectItem
                      ? STYLE_VARS.textColor
                      : STYLE_VARS.fccDarkerGrey,
                  fontWeight: '500',
                  letterSpacing: 1,
                }}
              >
                {department.title}
              </Text>
            </TouchableOpacity>
          </View>
        ))}
        {selectItem === 'other' && (
          <View
            style={{
              borderWidth: 0.5,
              borderColor: STYLE_VARS.fccDarkGrey,
              width: '100%',
            }}
          >
            <TextInput
              placeholder="ENTER OTHER DEPARTMENT"
              onChangeText={(text: string) => {
                if (onChangeOtherText) onChangeOtherText(text);
              }}
              value={otherText}
              placeholderTextColor={STYLE_VARS.fccDarkGrey}
              style={[styles.input]}
            />
          </View>
        )}
      </View>
    </View>
  );
};

export default DepartmentSelect;

const styles = StyleSheet.create({
  input: {
    height: 40,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    paddingVertical: 10,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
  },
});
